import { render } from "./PDHInfoDisplay.vue?vue&type=template&id=8df7df30&scoped=true"
import script from "./PDHInfoDisplay.vue?vue&type=script&lang=js"
export * from "./PDHInfoDisplay.vue?vue&type=script&lang=js"

import "./PDHInfoDisplay.vue?vue&type=style&index=0&id=8df7df30&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df7df30"]])

export default __exports__